import { ENVIRONMENT_INITIALIZER, NgModule } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import { EffectsModule } from '@ngrx/effects';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { CoreGoogleAnalyticEffects } from './+state';

@NgModule({
  imports: [
    // google tag manager
    GoogleTagManagerModule.forRoot({
      id: environment.gtmConfig.GTM_ID,
      gtm_auth: environment.gtmConfig.GTM_AUTH,
      gtm_preview: environment.gtmConfig.GTM_PREVIEW,
    }),
    EffectsModule.forFeature([CoreGoogleAnalyticEffects]),
  ],
  providers: [
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue() {
        //
      },
    },
  ],
  exports: [GoogleTagManagerModule],
})
export class GoogleAnalyticModule {}
